var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"radio-icon"},[_c('span',{staticClass:"custom-radio"},[_c('span',{staticClass:"outer-circle"},[_c('span',{staticClass:"inner-circle",class:{ active: _vm.active }})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }